import CityPageTemplate from "@/pages/city-template/CityPageTemplate";
import { greenvilleScConfig } from "./data";

export default function GreenvilleSCPage() {
  return <CityPageTemplate config={greenvilleScConfig} />;
}